import { AddImages } from "@coworker/apprestructured/src/task-management/components/AddImages/AddImages";
import EmptyObject from "@coworker/apprestructured/src/task-management/types/EmptyObject";
import {
  CreatorFragmentCommonProps,
  CreatorFragmentHandle,
} from "@coworker/apprestructured/src/task-management/components/TaskCreatorAndEditorSheet/creator-fragments/CreatorFragment";
import { getByPath } from "@coworker/apprestructured/src/shared/helpers/object.helper";
import { Ref, useCallback } from "react";
import { isLoading } from "@coworker/apprestructured/src/task-management/loading";

const EMPTY_FILE_ARRAY: File[] = [];

export type AddImagesCreatorFragmentConfigProps = EmptyObject;

type AddImagesCreatorFragmentProps = {
  configProps: AddImagesCreatorFragmentConfigProps;
  commonProps: CreatorFragmentCommonProps;
  ref?: Ref<CreatorFragmentHandle>;
};

function AddImagesCreatorFragment({
  commonProps,
}: AddImagesCreatorFragmentProps) {
  const { blockInput, task, onTaskChange } = commonProps;
  const images = getByPath<File[]>(task, "images");
  const handleConfirmClick = useCallback(
    (newImages: File[]) => {
      onTaskChange({ images: newImages });
    },
    [onTaskChange]
  );

  return (
    <AddImages
      images={isLoading(images) ? EMPTY_FILE_ARRAY : images}
      onConfirmClick={handleConfirmClick}
      disabled={blockInput || isLoading(images)}
    />
  );
}

export default AddImagesCreatorFragment;
